import { FontWeights, mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    backdrop: {
      display: 'flex',
      position: 'fixed',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      zIndex: 10,
      height: '100vh',
    },
    modalDialog: {
      backgroundColor: theme.palette.white,
      height: '90%',
      width: '80%',
      maxWidth: '370px',
      borderRadius: '4px',
      boxShadow: theme.effects.elevation8,
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '4px',
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    topPanel: {
      display: 'flex',
      padding: '8px 12px',
      gap: '8px',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.neutralLight}`,
      '& .ms-Toggle': {
        marginBottom: 0,
      }
    },
    bottomPanel: {
      display: 'flex',
      padding: '8px 12px',
      gap: '12px',
      borderTop: `1px solid ${theme.palette.neutralLight}`,
      boxSizing: 'border-box',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    controlLabel: {
      color: theme.semanticColors.inputText,
    },
    groupHeader: {
      minHeight: '32px',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '12px',
      fontWeight: FontWeights.semibold,
      fontSize: '14px',
      color: theme.palette.neutralTertiary,
      backgroundColor: theme.palette.neutralLighter,
    }
  })
}
